"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.filter.js");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _values2 = _interopRequireDefault(require("lodash/values"));
var _some2 = _interopRequireDefault(require("lodash/some"));
var _toLower2 = _interopRequireDefault(require("lodash/toLower"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));
var _Accent = require("@nerdwallet/currency/components/Accent");
var _Tooltip = require("@nerdwallet/currency/components/Tooltip");
var _constants = require("./constants");
var _quickFactValue = _interopRequireDefault(require("./quick-fact-value"));
var _quickFactsModule = _interopRequireDefault(require("./quick-facts.module.css"));
var QuickFacts = function QuickFacts(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    quickFacts = _ref.quickFacts,
    _ref$groupLabelAndVal = _ref.groupLabelAndValue,
    groupLabelAndValue = _ref$groupLabelAndVal === void 0 ? false : _ref$groupLabelAndVal;
  var quickFactComponents = [];
  var filteredQuickFacts = quickFacts.filter(function (quickFact) {
    return quickFact && !(0, _isNil2.default)(quickFact.value) || groupLabelAndValue;
  });
  if ((0, _isEmpty2.default)(filteredQuickFacts)) {
    return null;
  }
  var rewardsDrivers = filteredQuickFacts.some(function (quickFact) {
    return (0, _toLower2.default)(quickFact.label).indexOf('rewards') >= 0;
  });

  // Need to use a forEach here because styling will not work if each
  // quickFact is wrapped in an enclosing div. All items must be
  // direct siblings.
  filteredQuickFacts.forEach(function (quickFact) {
    var _ref2;
    var labelNode = /*#__PURE__*/_react.default.createElement("div", {
      key: "".concat(quickFact.id, "-label"),
      className: (0, _classnames.default)([_quickFactsModule.default.cell, _quickFactsModule.default.label, (0, _classes.default)('padding-bottom-2')])
    }, quickFact.labelTooltip ? /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
      id: quickFact.id,
      label: /*#__PURE__*/_react.default.createElement(_Accent.Accent, {
        size: "small"
      }, quickFact.label),
      content: quickFact.labelTooltip,
      title: "More information about ".concat(quickFact.label)
    }) : /*#__PURE__*/_react.default.createElement(_Accent.Accent, {
      size: "small"
    }, quickFact.label));
    var valueNode = /*#__PURE__*/_react.default.createElement("div", {
      key: "".concat(quickFact.id, "-value"),
      className: (0, _classnames.default)([_quickFactsModule.default.cell, _quickFactsModule.default.value])
    }, /*#__PURE__*/_react.default.createElement(_quickFactValue.default, {
      quickFact: quickFact,
      showNAForEmptyValue: groupLabelAndValue
    }));
    var fullWidthDriver = (0, _toLower2.default)(quickFact.label).indexOf('regular apr') >= 0;
    if (groupLabelAndValue) quickFactComponents.push( /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)([_quickFactsModule.default.driverColumn, (_ref2 = {}, (0, _defineProperty2.default)(_ref2, _quickFactsModule.default.centeredDriver, rewardsDrivers), (0, _defineProperty2.default)(_ref2, _quickFactsModule.default.fullWidthDriver, fullWidthDriver), _ref2)])
    }, labelNode, valueNode));else {
      quickFactComponents.push(labelNode);
      quickFactComponents.push(valueNode);
    }
  });
  var hasWideDriver = (0, _some2.default)(filteredQuickFacts, 'wide');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)([className, groupLabelAndValue ? _quickFactsModule.default.quickFactsFlex : _quickFactsModule.default.quickFactsTable, _quickFactsModule.default["table".concat(filteredQuickFacts.length, "Cols")]], (0, _defineProperty2.default)({}, _quickFactsModule.default.hasWideDriver, hasWideDriver))
  }, quickFactComponents);
};
QuickFacts.propTypes = {
  /** Class name(s) to apply to the component */
  className: _propTypes.default.string,
  /** List of quick facts to display */
  quickFacts: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** The unique id for this particular quick fact */
    id: _propTypes.default.string.isRequired,
    /** The quick fact label text */
    label: _propTypes.default.node,
    /** The popover text to be associated with the label */
    labelTooltip: _propTypes.default.node,
    /** The quick fact value */
    value: _propTypes.default.node,
    /** Specifies how the value should be formatted.
    Supports 'currency', 'currencyWithCents', 'percent', 'string', and 'unformatted'.
    Defaults to 'string'. */
    valueFormat: _propTypes.default.oneOf((0, _values2.default)(_constants.FORMATS)),
    /** The popover text to be associated with the value */
    valueTooltip: _propTypes.default.node,
    /** The type size of the value. Supports 'large' and 'small'.
     Defaults to 'large'. */
    valueSize: _propTypes.default.oneOf((0, _values2.default)(_constants.VALUE_SIZES)),
    /** The quick fact description */
    description: _propTypes.default.node,
    /** Whether to display the driver in wider width, e.g. the LOA driver */
    wide: _propTypes.default.bool
  })).isRequired,
  groupLabelAndValue: _propTypes.default.bool
};
var _default = QuickFacts;
exports.default = _default;